/**
 * Labels for editor section field headers (data-editor="field-header").
 * Use these constants so section titles stay consistent and are easy to change.
 */
export const EDITOR_FIELD_HEADERS = {
  GRID: "Grid",
  BAR_CHART: "Bar Chart",
  TABLE: "Table",
  DATA_DISTRIBUTION: "Data Distribution",
  MONTHLY_OVERVIEW: "Monthly Overview",
  MONTHLY_SUMMARY: "Monthly Summary",
  CTA: "CTA",
  CONDITIONAL_CTA: "Conditional CTA",
  CTA_OVERLAY: "CTA Overlay",
  IMAGE: "Image",
  TEXT: "Text",
  TITLE: "Title",
  CELLS: "Cells",
  CELL: "Cell",
  MONTHLY_OVERVIEW_LEGACY: "monthlyOverview",
} as const;
